<template>
  <Grid class="products-table body bg-white-1 q-pl-md q-pr-lg q-py-lg">
    <q-inner-loading :showing="loading" style="z-index: 1">
      <q-spinner color="secondary-1" size="2rem" />
    </q-inner-loading>

    <AgGrid
      v-if="showTable"
      ref="agGrid"
      :header-height="48"
      :options="gridOptions"
      :api-request="infiniteScrollRequest"
      :context="context"
      class="q-px-sm"
      style="grid-template-rows: 1fr"
      @ready="onGridReady"
      @export-loading="setExportLoading"
    >
    </AgGrid>
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
// Mixins
import { exportToExcel } from '@/mixins/export-to-excel'
import gridOptionsMixin from './gridOptions'
// Libraries
import { mapState, mapMutations, mapActions } from 'vuex'
// Components
import AgGrid from '@/ag-grid/AgGrid'

export default {
  components: {
    AgGrid
  },

  mixins: [exportToExcel, gridOptionsMixin],

  data: () => ({
    agGrid: null,
    showTable: false,
    context: {}
  }),

  computed: {
    ...mapState('lv-products', ['loading', 'tableState']),
    ...mapState({ metadataColumns: state => state.products.metaDataColumns })
  },

  async created() {
    await this.fillData()
    await this.getAndSetTableState()
    this.showTable = true
    this.context = { parentCmp: this }
  },

  beforeDestroy() {
    this.storeTableState()
    this.$store.dispatch('lv-products/saveTableState')
  },

  methods: {
    ...mapMutations('lv-products', ['setLoading', 'setExportLoading']),
    ...mapActions('lv-products', ['getAndSetTableState']),

    infiniteScrollRequest(request) {
      return apiTo.GET_PAGINATED_PRODUCTS(request)
    },

    fillData() {
      this.setLoading(true)

      return Promise.all([
        this.$store.dispatch('products/getCreateFormData'),
        this.$store.dispatch('subscriptions/subscriptionPeriods/getCreateFormData'),
        this.$store.dispatch('products/getMetaDataColumns'),
        this.$store.dispatch('products/getSubjectCategories')
      ]).finally(() => this.setLoading(false))
    },

    onGridReady(agGrid) {
      this.agGrid = agGrid
      this.$emit('ag-grid', agGrid)
      this.tableState.filter && this.agGrid.api.setFilterModel(this.tableState.filter)
      this.tableState.columns && this.agGrid.columnApi.setColumnState(this.tableState.columns)
    },

    storeTableState() {
      const filterModel = this.agGrid.api.getFilterModel()
      const columnState = this.agGrid.columnApi.getColumnState()

      this.$store.commit('lv-products/setTableStateFilter', filterModel)
      this.$store.commit('lv-products/setTableStateColumns', columnState)
    },

    async startAcquisition(row) {
      await this.$store.dispatch('subscriptions/subscriptionPeriods/setProductId', row.id)
      this.$emit('show-subscription-modal')
    },

    exportToExcel() {
      this.mixinExportToExcel(this.$refs.agGrid.getGridOptions(), [], 'products', undefined, ['actions'])
    }
  }
}
</script>
